import React from "react";

export type NavigationProps = {
  to?: string;
  exact?: boolean;
};

export const checkIsActiveByChildren = (children: React.ReactNode, path: string) => {
  if (children === null) return false;
  let isFind = false;
  if (React.Children.count(children) > 0) {
    React.Children.forEach(children, element => {
      if (!React.isValidElement(element)) return false;
      const props: NavigationProps = element.props as NavigationProps;
      if (props.to && path.startsWith(props.to)) {
        isFind = true;
      }
    });
  }
  return isFind;
};
